module.exports = __webpack_public_path__ + "static/media/im-rahmen-app.bd91a4b1.mp4";